import userPermissions from "@/services/userPermission.service";
// import Formatter from '@/functions/Formatter';

const state = {
    permissions: []
}

const mutations = {
    SET_PERMISSIONSS(state, data){
        state.permissions = data;
    }
}

const actions = {
    async fetchPermissions({ commit }){
        let response = undefined;
        try{
            response = await userPermissions.getAll();
            commit("SET_PERMISSIONSS", response.data);
        }
        catch (error) {
            console.log(error);
        }

        return new Promise((resolve) => {
            resolve(response.data);
        })
    },
    clearPermissions({ commit }){
        commit("SET_PERMISSIONS", 0);
    }
}

const getters = {
    getPermissionByTitle: (state) => (title) => {
        return state.permissions.find(perm => perm.title === title);
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}